let _events = [];

function enqueueEvent(event) {
    enqueueEvents([event]);
}

function enqueueEvents(events) {
    _events = _events.concat(events);
}

function hasEvents() {
    return !!_events.length;
}

function dequeueAllEvents() {
    const events = _events;
    _events = [];
    return events;
}

export default {
    enqueueEvent,
    enqueueEvents,
    dequeueAllEvents,
    hasEvents,
};
